import { css } from '@microsoft/fast-element';

export const ErrorUploadGridStyles = css`
  table {
    border-collapse: collapse;
  }

  .table-title-container {
    width: 100%;
    height: 32px;
    box-sizing: border-box;
    border-bottom: 1px solid var(--font-color-1);
  }

  .table-value-container {
    width: 100%;
    height: 32px;
    background-color: #342c15;
    border-bottom: 16px solid var(--side-menu-bg);
  }

  .table-title {
    color: var(--font-color-1);
    font: 13px Roboto-Bold, Roboto, sans-serif;
    text-align: left;
    padding: 0 12px;
    white-space: nowrap;
  }

  .table-value {
    padding: 0 12px;
    font: 12px Roboto-Regular, Roboto, sans-serif;
  }

  .error-value {
    color: rgb(255 182 96 / 99%);
    font: 12px Roboto-Regular, Roboto, sans-serif;
    border-color: rgb(255 182 96 / 30%);
    border-width: 0 1px 1px;
    border-style: solid;
    position: relative;
    z-index: 100px;
  }

  .name-col {
    color: var(--nest-level-tab-font);
    min-width: 50px;
    white-space: nowrap;
    max-width: 150px;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .warning-col {
    width: 25px;
  }

  .warning-icon {
    width: 18px;
    height: 18px;
  }

  .main-text {
    display: inline-block;
  }

  .hover-error {
    visibility: hidden;
    background-color: #787272;
    color: #fff;
    text-align: center;
    padding: 4px;
    position: fixed;
    z-index: 100;
    top: auto;
    right: auto;
    border-radius: 2px;
    margin-top: 20px;
  }

  .error-value:hover .hover-error {
    visibility: visible;
  }
`;
